import { CreateRoomRequest, fileService } from "@/services/ServiceRegistry";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { useCreateRoom } from "@/hooks/useRooms";
import { CreateRoomFormData } from "../../utils/roomSchema";

export const useRoomCreate = () => {
  const navigate = useNavigate();
  const createRoomMutation = useCreateRoom();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRoomCreate = async (
    data: CreateRoomFormData,
    hotelId: string,
    selectedPhotoFile: File | null,
  ) => {
    try {
      setIsLoading(true);
      const { number, categoryId, status, floor, area } = data;

      let photoFileId = null;

      if (selectedPhotoFile) {
        try {
          photoFileId =
            await fileService.uploadFileWithPresignedUrl(selectedPhotoFile);
        } catch (photoError) {
          console.error("Failed to upload photo:", photoError);
        }
      }

      const roomRequest: CreateRoomRequest = {
        number,
        categoryId,
        status,
        floor,
        area,
        ...(photoFileId && { photoId: photoFileId }),
        hotelId: hotelId!,
      };

      // Create the room using the service
      await createRoomMutation.mutateAsync(roomRequest);

      // Navigate back to reservations list
      navigate("/reservations/rooms");
    } catch (error) {
      toast.error((error as Error).message);
      setError((error as Error).message);
      console.error("Error creating room:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleRoomSubmit: handleRoomCreate,
    isLoading: isLoading,
    error: error,
  };
};
